// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"8dff36a7","478":"80286edd","700":"f4fa187e"}[chunkId] + ".chunk.css";
};